import React, { Component, PropTypes } from 'react';

import Header from './Header';
import DaySelector from './DaySelector';
import TimeGrid from './TimeGrid';

import './TimeSelector.css';

export default class TimeSelector extends Component {
    static defaultProps = {
        hasInstantSave: false,
    }

    static propTypes = {
        initialStart: PropTypes.object.isRequired,
        initialEnd: PropTypes.object.isRequired,
        roundedStart: PropTypes.object.isRequired,
        roundedEnd: PropTypes.object.isRequired,
        roundedMinStart: PropTypes.object.isRequired,
        roundedMaxEnd: PropTypes.object.isRequired,
        canEditStart: PropTypes.bool.isRequired,
        canEditEnd: PropTypes.bool.isRequired,
        onSave: PropTypes.func.isRequired,
        onClose: PropTypes.func,
        hasInstantSave: PropTypes.bool.isRequired,
        initialFocusTime: PropTypes.object,
        title: PropTypes.string,
        startTimeUnavailabilityReasons: PropTypes.array.isRequired,
        endTimeUnavailabilityReasons: PropTypes.array.isRequired,
        onUnavailableTimeSlotClicked: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.state = {
            newStart: null,
            newEnd: null,
            focusTime: props.initialFocusTime,
        };

        this.onStartChanged = this.onStartChanged.bind(this);
        this.onEndChanged = this.onEndChanged.bind(this);
        this.onDaySelected = this.onDaySelected.bind(this);
        this.save = this.save.bind(this);
    }

    onStartChanged(newStart) {
        this.setState(
            { newStart },
            () => {
                if (this.props.hasInstantSave)
                    this.save();
            }
        );
    }

    onEndChanged(newEnd) {
        this.setState(
            { newEnd },
            () => {
                if (this.props.hasInstantSave)
                    this.save();
            }
        );
    }

    onDaySelected(day) {
        const { roundedMinStart, roundedMaxEnd, roundedStart, roundedEnd } = this.props;
        const startTime = this.state.newStart !== null
            ? this.state.newStart
            : this.props.roundedStart;
        const endTime = this.state.newEnd !== null
            ? this.state.newEnd
            : this.props.roundedEnd;
        const goToBookingStartTime = startTime.clone().startOf(`day`).diff(day, `days`) === 0;
        const goToBookingEndTime = endTime.clone().startOf(`day`).diff(day, `days`) === 0;

        if(goToBookingStartTime || goToBookingEndTime) {
            // go to the start or end time depending on which one is on the day we clicked, start time takes preference
            if(goToBookingStartTime) {
                day.hours(startTime.hour());
            }
            else if (goToBookingEndTime) {
                day.hours(endTime.hour());
            }
        }
        else {
            // default handling
            day.hours(8);

            if (day.isBefore(roundedMinStart))
                day.hours(roundedMinStart.hours());
            else if (day.isAfter(roundedMaxEnd))
                day.hours(roundedMaxEnd.hours());
        }

        this.setState({
            focusTime: day,
        });
    }

    save() {
        const { newStart, newEnd } = this.state;

        // Only save when one of the times have changed
        if (newStart || newEnd)
            this.props.onSave(newStart, newEnd);
        else if (this.props.onClose)
            this.props.onClose();
    }

    render() {
        const { initialStart, initialEnd } = this.props;
        const { newStart, newEnd, focusTime } = this.state;
        const start = newStart || initialStart;
        const end = newEnd || initialEnd;

        return (
            <div className="time-selector">
                <Header
                    start={start}
                    end={end}
                    title={this.props.title}
                    onSave={this.save}
                    onClose={this.props.onClose}
                    hasButtons={!this.props.hasInstantSave}
                />
                <div className="time-selector-contents">
                    <TimeGrid
                        newStart={newStart}
                        newEnd={newEnd}
                        minStartDate={this.props.roundedMinStart}
                        maxEndDate={this.props.roundedMaxEnd}
                        onStartChanged={this.onStartChanged}
                        onEndChanged={this.onEndChanged}
                        focusTime={focusTime}
                        {...this.props}
                    />
                    <DaySelector
                        start={start}
                        end={end}
                        minStartDate={this.props.roundedMinStart}
                        maxEndDate={this.props.roundedMaxEnd}
                        onDaySelected={this.onDaySelected}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Common/TimeSelector/TimeSelector.jsx